import type { ValidatorFn } from '@angular/forms';

export interface FormField<T> {
  key: string;
  label: string;
  type: T; //  type: 'text' | 'select' | 'textarea' | 'checkbox' | 'radio' | 'date' | 'number' | 'email' | 'password'; // Include more types as needed
  options?: { value: string; label: string }[]; // For select, radio, checkbox
  placeholder?: string;
  validation?: ValidatorFn[]; // Angular reactive-forms validators (e.g. [Validators.required])
  tooltip?: string;
  tooltipPosition?: string; //below, above, left, right
}
